/* Ownership comes from Accounts' origin-checked session bridge or the signed Shopify proxy. */
(() => {
  const script=document.querySelector('script[data-sf-ownership]');if(!script)return;
  let owned=new Set(), accountAuthoritative=false;
  const previous = new Map();
  function reset(){
    for(const [node, values] of previous){node.hidden=values.hidden;if(values.disabled!==undefined)node.disabled=values.disabled;}
    previous.clear();
    for(const panel of document.querySelectorAll('.sf-owned-product'))panel.remove();
    for(const product of document.querySelectorAll('[data-sf-owned]'))delete product.dataset.sfOwned;
  }
  function preserve(node){if(!previous.has(node))previous.set(node,{hidden:node.hidden,disabled:node.disabled});}
  function apply(root=document){
    for(const product of root.querySelectorAll('[data-sf-product-id],product-info[data-product-id]')){
      if(!owned.has(product.dataset.sfProductId||product.dataset.productId))continue;
      if(product.dataset.sfOwned!=='true')product.dataset.sfOwned='true';
      // Removing the forms also removes accelerated and quick-add purchase paths.
      for(const node of product.querySelectorAll('product-form,.quick-add,.quick-add-bulk,.sf-product-wishlist,.product-form__quantity,.product-form__input')){node.querySelector?.('dialog[open]')?.close();if(!node.hidden){preserve(node);node.hidden=true;}}
      for(const button of product.querySelectorAll('button[name="add"],.shopify-payment-button__button')){if(!button.disabled){preserve(button);button.disabled=true;}}
      if(product.querySelector('.sf-owned-product'))continue;
      const panel=document.createElement('div');panel.className='sf-owned-product';
      const badge=document.createElement('span');badge.className='sf-store-badge';badge.dataset.bladeComponent='sf-badge-soft';badge.dataset.bladeRevision='1.6';badge.textContent='In your library';panel.append(badge);
      const mainCopy=product.querySelector('.product__info-container');
      if(mainCopy){
      const actions=document.createElement('div');actions.className='sf-owned-product-actions';
      for(const [label,url] of [
        ['Downloads','https://account.sofly.io/portal/index.html?section=downloads#downloads'],
        ['Get support','https://support.sofly.io/tickets?product='+encodeURIComponent(product.dataset.sfProductHandle||'')],
        ['Open desktop app','sofly://library']
      ]){const link=document.createElement('a');link.className='button button--secondary';link.textContent=label;link.href=url;link.dataset.bladeComponent='sf-button-secondary';link.dataset.bladeRevision='1.6';actions.append(link);}
      panel.append(actions);
      }
      const copy=mainCopy||product.querySelector('.sf-store-product-copy')||product.querySelector('.card__information')||product.querySelector('.card__content:last-child');
      const purchase=copy?.querySelector('product-form')?.parentElement;
      if(purchase)purchase.before(panel);else(copy||product).append(panel);
    }
  }
  document.addEventListener('sofly:account-state',event=>{
    accountAuthoritative=true;reset();owned=new Set((event.detail.ownedProductIds||[]).map(String));apply();
  });
  document.addEventListener('shopify:section:load',()=>apply());
  new MutationObserver(()=>apply()).observe(document.body,{childList:true,subtree:true});
  if(script.dataset.shopifyCustomer!=='true')return;
  fetch(script.dataset.endpoint,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw new Error('Ownership unavailable');return r.json();}).then(data=>{
    if(accountAuthoritative||!data.signedIn||!Array.isArray(data.ownedProductIds))return;
    owned=new Set(data.ownedProductIds.map(String));apply();

  }).catch(()=>{/* Keep ordinary product actions when ownership cannot be verified. */});
})();
